import { warn } from '@1hive/connect-core';
import { useConnect } from './use-connect';
import { hash } from './utils';
export function useOrganization() {
    warn('useOrganization() is going to be deprecated in the next version. ' +
        'Please use useConnect() instead.');
    return useConnect((organization) => organization);
}
export function useApp(appsFilter) {
    warn('useApp() is going to be deprecated in the next version. ' +
        'Please use useConnect() instead.');
    return useConnect((org) => org.onApp(appsFilter), [
        hash(appsFilter),
    ]);
}
export function useApps(appsFilter) {
    warn('useApps() is going to be deprecated in the next version. ' +
        'Please use useConnect() instead.');
    return useConnect((org) => org.onApps(appsFilter), [hash(appsFilter)]);
}
export function usePermissions() {
    warn('usePermissions() is going to be deprecated in the next version. ' +
        'Please use useConnect() instead.');
    return useConnect((org) => org.onPermissions());
}
//# sourceMappingURL=deprecated-hooks.js.map